/* Areté: pagina prodotto e carrello (caricato solo su quei due template da layout/theme.liquid).
   Senza questo script tutto funziona lo stesso: la galleria scorre col dito, il modulo e il carrello
   sono form nativi. Qui solo:
   - galleria: miniature e puntini fanno scorrere la pista e seguono la foto visibile;
   - quantita': i bottoni - e + attorno al campo numerico;
   - varianti: prezzo, prezzo a dose e bottone seguono la variante scelta (solo con opzioni vere);
   - barra del telefono: compare quando il bottone del carrello e' uscito dallo schermo, verso l'alto;
   - carrello: "Aggiorna il carrello" si accende quando cambia una quantita';
   - paese: fuori dai paesi del negozio il modulo lascia il posto a "spediamo solo in" + cambio paese.
   Clic e cambi passano da un listener sul documento (niente doppioni quando il Theme Editor ricarica
   una sezione); gli observer si riavviano su shopify:section:load e si staccano su unload. */
(() => {
  const piano = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const osservatori = new Map(); // radice -> [IntersectionObserver]

  const ferma = radice => {
    for (const io of osservatori.get(radice) || []) io.disconnect();
    osservatori.delete(radice);
  };

  const avvia = radice => {
    ferma(radice);
    const lista = [];

    // galleria: la miniatura (o il puntino) della foto visibile prende aria-current
    for (const g of radice.querySelectorAll('[data-galleria]')) {
      const pista = g.querySelector('[data-pista]');
      const foto = pista ? [...pista.children] : [];
      if (foto.length < 2) continue;
      const comandi = [...g.querySelectorAll('[data-vai-foto]')];
      const io = new IntersectionObserver(es => {
        for (const e of es) {
          if (!e.isIntersecting) continue;
          const i = foto.indexOf(e.target);
          for (const c of comandi) {
            if (+c.dataset.vaiFoto === i) c.setAttribute('aria-current', 'true');
            else c.removeAttribute('aria-current');
          }
        }
      }, {root: pista, threshold: .6});
      foto.forEach(f => io.observe(f));
      lista.push(io);
    }

    // barra del telefono: visibile solo se il bottone del carrello e' sopra lo schermo
    for (const barra of radice.querySelectorAll('[data-barra]')) {
      const sezione = barra.closest('section');
      const bottone = sezione && sezione.querySelector('[data-aggiungi]');
      if (!bottone) continue;
      const io = new IntersectionObserver(([e]) => {
        const mostra = !e.isIntersecting && e.boundingClientRect.top < 0;
        barra.classList.toggle('is-visibile', mostra);
        barra.inert = !mostra;
      });
      io.observe(bottone);
      lista.push(io);
    }

    // fuori dai paesi del negozio Shopify segna il prodotto non disponibile: invece di "Esaurito" si dice
    // dove si spedisce. Il paese vero e' solo in Shopify.country, Liquid vede quello del mercato.
    for (const p of radice.querySelectorAll('[data-paesi]')) {
      const qui = window.Shopify && Shopify.country;
      const fuori = !!qui && !p.dataset.paesi.split(',').includes(qui);
      p.hidden = !fuori;
      const modulo = document.getElementById(p.dataset.modulo);
      if (modulo) modulo.hidden = fuori;
    }

    if (lista.length) osservatori.set(radice, lista);
  };

  // varianti: dati preparati in Liquid (prezzi gia' formattati con il formato del negozio)
  const cambiaVariante = select => {
    const sezione = select.closest('section');
    const dati = sezione && sezione.querySelector('[data-varianti]');
    if (!dati) return;
    const v = JSON.parse(dati.textContent).find(x => String(x.id) === select.value);
    if (!v) return;
    const vendibile = v.disponibile && v.cent > 0;
    sezione.querySelectorAll('[data-prezzo]').forEach(el => { el.textContent = v.prezzo; });
    const prima = sezione.querySelector('[data-prima]');
    if (prima) {
      prima.hidden = !v.prima;
      prima.querySelector('[data-prima-valore]').textContent = v.prima;
    }
    const dose = sezione.querySelector('[data-dose]');
    if (dose) { dose.hidden = !v.dose; dose.textContent = v.dose; }
    const bottone = sezione.querySelector('[data-aggiungi]');
    if (bottone) { bottone.disabled = !vendibile; bottone.textContent = vendibile ? bottone.dataset.si : bottone.dataset.no; }
    const barra = sezione.querySelector('[data-aggiungi-barra]');
    if (barra) barra.disabled = !vendibile;
    for (const el of sezione.querySelectorAll('[data-qta], [data-subito]')) el.hidden = !vendibile;
    const url = new URL(location.href);
    url.searchParams.set('variant', v.id);
    history.replaceState(history.state, '', url);
  };

  document.addEventListener('click', e => {
    const t = e.target;
    if (!(t instanceof Element)) return;

    // miniature e puntini: la pista scorre fino alla foto scelta
    const vai = t.closest('[data-vai-foto]');
    if (vai) {
      const pista = vai.closest('[data-galleria]').querySelector('[data-pista]');
      const foto = pista && pista.children[+vai.dataset.vaiFoto];
      if (foto) pista.scrollTo({left: foto.offsetLeft - pista.firstElementChild.offsetLeft, behavior: piano() ? 'auto' : 'smooth'});
    }

    // - e + : stepDown/stepUp rispettano min; poi un evento change come se si fosse scritto nel campo
    const passo = t.closest('[data-passo-qta]');
    if (passo) {
      const campo = passo.parentElement.querySelector('input[type="number"]');
      if (!campo) return;
      const prima = campo.value;
      if (+passo.dataset.passoQta > 0) campo.stepUp(); else campo.stepDown();
      if (campo.value !== prima) campo.dispatchEvent(new Event('change', {bubbles: true}));
    }
  });

  document.addEventListener('change', e => {
    const t = e.target;
    if (!(t instanceof Element)) return;
    if (t.matches('[data-variante]')) cambiaVariante(t);
    // carrello: una quantita' cambiata accende "Aggiorna il carrello" (il checkout le applica comunque)
    if (t.matches('#carrello-form input[name="updates[]"]')) {
      const aggiorna = t.form && t.form.querySelector('[data-aggiorna]');
      if (aggiorna) aggiorna.classList.add('is-attivo');
    }
  });

  // Theme Editor
  document.addEventListener('shopify:section:load', e => avvia(e.target));
  document.addEventListener('shopify:section:unload', e => ferma(e.target));

  avvia(document);
})();
